import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Redirect } from 'react-router-dom';
import Block, { BlockHeader } from '../Block';
import { getString as s } from '../../lib/strings';
import { getShow as show } from '../../lib/show';
import Button from '../Button';
import Layout, { LayoutBody } from '../Layout';
import LoginError from './LoginError';
import Loader from '../Loader';
import { Brands } from './../../common/constants';
import { getAssetUrl } from '../../lib/getWLSAssetsUrl'; 

const Container = styled(Layout)`
  @media only screen and (min-width: 425px) {
    margin-top: ${(props) => props.theme.whitespace.xl};
  }
`;

const EmailBlock = styled(Block)`
  border-top: none;
  padding-top: 0;
  margin-bottom: 20px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

const Form = styled.form`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
`;
const Input = styled.input`
  ${(props) => props.theme.type.base};
  ${(props) => `
    padding: ${props.theme.whitespace.xs} ${props.theme.whitespace.small};
    border: ${props.theme.borders.width} solid ${props.theme.colours.border};
    border-radius: ${props.theme.borders.radius} 0 0 ${props.theme.borders.radius}; 
    font-family: ${props.theme.type.h3.fontFamily};
    margin: 0;
    margin-right: ${props.theme.whitespace.addon || '-1px'};
  `};
  outline: none;
  width: 100%;
  box-sizing: border-box;
  flex: 1;
`;
const SubmitButton = styled(Button)`  
  ${(props) => `
    border-radius: 0 ${props.theme.borders.radius} ${props.theme.borders.radius} 0;
    padding: 5px 20px;
  `}
`;
const InputError = styled.div`
  color: #eb1701;
  font-size: 12px;
`;

const WlsDeviceImage = styled.img`
 display: block;
  width: 100%;              
  height: 270px;               
  object-fit: contain;      
  
  @media only screen and (max-width: 480px) {
    height: 200px;
  }
`;

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = { email: '', inputValid: true };
    this.update = this.update.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onSubmitClick = this.onSubmitClick.bind(this);
    this.login = this.login.bind(this);
    this.remoteLogin = this.remoteLogin.bind(this);
    this.textInput = React.createRef();
  }
  onBlur() {
    const inputValid =
      this.textInput.checkValidity() && this.state.email.length > 0;
    this.setState({ inputValid });
  }
  onFocus() {
    this.setState({ inputValid: true });
  }
  onSubmitClick(e){
    if(!this.state.inputValid) {
      e.preventDefault();
    }
  }

  getUrl(origin = window.location.origin) {
    const urlParts = this.getUrlParts(this.props.brand);
    return this.getDomainPrefix(this.props.brand, origin) + urlParts.domain;
  }

  getDomainPrefix(brand, origin = window.location.origin) {
    const urlParts = this.getUrlParts(brand);
    let domainPrefix = '';
    // fix to stop flooding prod db when on development
    if (origin.includes('uat') || origin.includes('localhost')) {
      domainPrefix = `uat${  urlParts.prefix}`;
    } else if (origin.includes('staging')) {
      domainPrefix = `staging${  urlParts.prefix}`;
    }
    return domainPrefix;
  }

  getUrlParts(brand) { // eslint-disable-line
    const brandDomainMap = {
      [Brands.TheSun] : { domain: 'thesun.co.uk',
                prefix: '-'},
      [Brands.TheTimes] : { domain: 'thetimes.co.uk',
                prefix: '-'},
      [Brands.TheTimesCom] : { domain: 'thetimes.com',
                prefix: '-'},
      [Brands.Wireless] : { domain: 'wireless.radio',
                prefix: '.'},
      [Brands.Tls] : { domain: 'the-tls.co.uk',
                prefix: '.'},
      [Brands.TlsCom] : { domain: 'the-tls.com',
                prefix: '.'}
    };

    return brandDomainMap[brand];
  }

  getLoginUrl(origin = window.location.origin) {
    return `https://login.${this.getUrl(origin)}/?gotoUrl=${encodeURIComponent(origin)}`;
  }

  remoteLogin() {
    window.location.assign(this.getLoginUrl()); // eslint-disable-line
  }


  update(e) {
    this.setState({ email: e.target.value });
  }

  login(e) {
    e.preventDefault();
    if (this.state.email) {
      this.props.login(this.state.email);
    }
  }

  render() {
    const { isFetching, session, hasFetched, error, location } = this.props;

    const showEmailLogin = show('login.email',true);

    return session.token ? (
      <Redirect
        to={
          location.state && location.state.referrer
            ? location.state.referrer
            : '/'
        }
      />
    ) : (
      <Fragment>
        <Container role="form" className="login">
          <LayoutBody>
            {isFetching && <Loader isLoading={isFetching} />}
            {!isFetching && !hasFetched && !hasFetched && !error && (
            <Fragment >
              {showEmailLogin && (
              <EmailBlock>
                <BlockHeader
                  primary={s(
                        'login.title',
                        'Sign in or enter your email address to access the Permission Center'
                        )}
                  secondary={s(
                        'login.subtitle',
                        'To be able to manage your permissions you’ll need to enter your email address below and we’ll send you a link to verify your account'
                        )}
                  justify="center"
                />
                <Row>
                  <Form id="email_login_form" onSubmit={this.login}>
                    <Input
                      className={!this.state.inputValid ? 'error' : ''}
                      id="email_login_input"
                      name="email"
                      type="email"
                      innerRef={(ref) => {
                              this.textInput = ref;
                            }}
                      placeholder={s(
                            'login.form.placeholder',
                            'Enter your email...'
                            )}
                      onChange={this.update}
                      onBlur={this.onBlur}
                      onFocus={this.onFocus}
                    />
                    <SubmitButton id="email_login_submit" type="submit" onClick={this.onSubmitClick}>
                      {s('login.form.submit', 'Submit')}
                    </SubmitButton>
                  </Form>
                </Row>
                {!this.state.inputValid && (
                <InputError className="inputError">{s('login.form.invalid', '')}</InputError>
                      )}
              </EmailBlock>
                  )}
              { this.props.brand !== 'tls' && this.props.brand !== 'tls_com' &&
                ( <Block>
                  <BlockHeader
                    primary={s('login.account.title', 'Already registered?')}
                    secondary={s(
                          'login.account.subtitle',
                          'Sign into the permission center with your account'
                        )}
                  />
                  <Button className="button-signin" onClick={this.remoteLogin}>
                    {s('login.account.submit', 'Sign In')}
                  </Button>
                  </Block> )
                  }
            </Fragment>
              )}
            {hasFetched &&
              !error && (
                <EmailBlock>
                  <BlockHeader
                    primary={s('login.confirm.title', 'Check your email')}
                    secondary={s(
                      'login.confirm.subtitle',
                      'Check your email for a link to login to the permission center'
                    )}
                  />
                </EmailBlock>
              )}

            {error && <LoginError error={this.props.payload.code} />}
          </LayoutBody>
        </Container>
        {this.props.brand === 'wls' && (
        <WlsDeviceImage
          src={getAssetUrl('images/uwp/uwp-devices.webp')}
          alt="Wireless devices"
        />
      )}
      </Fragment>
    );
  }
}

Login.propTypes = {
  login: PropTypes.func.isRequired,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  brand: PropTypes.oneOf(['ngn', 'tnl', 'tnl_com', 'wls', 'tls', 'tls_com']).isRequired,
  hasFetched: PropTypes.bool,
  session: PropTypes.shape({
    token: PropTypes.string
  }),
  location: PropTypes.shape({
    state: PropTypes.shape({
      referrer: PropTypes.object
    }),
    pathname: PropTypes.string.isRequired
  }).isRequired,
  payload: PropTypes.shape({
    code: PropTypes.string
  }),
  isFetching: PropTypes.bool.isRequired
};

Login.defaultProps = {
  error: false,
  hasFetched: false,
  session: {},
  payload: {
    code: null
  }
};

export default Login;
